import * as React from 'react'
import { CircularProgress } from '@mui/material'
import { styled } from '../../theme/styled'

const LoaderContainer = styled.div`
  div {
    ${(p) => (p.color ? `color: ${p.color};` : '')}
  }
`

export const Loader = ({ color }: { color?: string }) => {
  return (
    <LoaderContainer color={color}>
      <CircularProgress />
    </LoaderContainer>
  )
}
